module.exports = __webpack_public_path__ + "media/public/images/icon-close-83fa0dbe2e01a2a0ac8520e0615954f9.svg";